export default "__VITE_ASSET__ff0f357c__"